import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div(({ overrideStyles }: { overrideStyles?: string }) => {
    return `
        position: relative;
        width: 100%;

        .cols {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .col-copy {
                padding: 2em;
                text-align: center;

                .headline {
                    font-size: 1.5em;
                    font-weight: 700;
                    color: #3E3E3E;
                    line-height: 1;
                }

                .subheadline {
                    font-size: 1.188em;
                    font-weight: 700;
                    margin-top: 1em;
                    color: #262626;
                }
            }

            .col-form {
                position: relative;
                width: 100%;
                z-index: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .form-container {
                    width: 50%;
                    color: white;
                    background-color: #484A52;
                    font-size: 95%;
                    border-top-left-radius: 7em;
                    border-bottom-right-radius: 7em;

                    .public-layout-forms-contact-form {
                        background-color: transparent;

                        .form-header {
                            padding: 0 2em 1em;

                            .headline {
                                font-weight: 700;
                                text-align: center;
                                font-size: 1.188em;
                            }
                        }

                    }
                }

                .background-image {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    z-index: -1;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    border-radius: 1.25em;
                }
            }
        }

        @media all and (max-width: ${variables.tabletL}) {
            .cols {
                flex-direction: column;
                align-items: flex-start;

                .col-copy {
                    width: 60%;
                    text-align: left;
                    font-size: 120%;
                }

                .col-form {
                    width: 100%;

                    .form-container {
                        .layout-forms-checkbox {
                            .label {
                                font-size: .8em;
                            }
                        }
                    }
                }
            }

            .background-image {
                width: 80%;
                height: 80%;
                left: auto;
                right: 0;
                background-position: 20% center;
            }
        }

        @media all and (max-width: ${variables.tabletS}) {
            .cols {
                .col-copy {
                    font-size: 100%;
                }
            }
        }

        @media all and (max-width: ${variables.mobileL}) {
            .cols {
                flex-direction: column;
                align-items: flex-start;

                .col-copy {
                    width: 100%;
                    text-align: center;
                }

                .col-form {
                    .form-container {
                        width: 100%;
                    }
                }
            }

            .background-image {
                display: none;
            }
        }
        @media all and (max-width: ${variables.mobileM}) {
            .cols {
                .col-copy {
                    padding: 2em 0;
                }
            }
        }

        ${overrideStyles}
    `;
});
